import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHCargoIns = async (credentials, data) => {
    const body = {
        service: "RNHCargoIns",
        params: {
            rnhCargoCod: data?.cod || null,
            rnhCargoNombre: data?.name || null,
            rnhTipoComponenteCod: data?.componenteCod || null,
            // Bandera "Y"/"N" del cargo. Con `|| null` porque las dos son strings
            // truthy: viaja lo que el formulario tenga, y null si no vino.
            rnhCargoPuedeEditar: data?.puedeEditar || null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
